<div
  class="toast-stack"
  aria-live="polite"
  data-testid="toast-stack"
  (mouseenter)="onPointer(true)"
  (mouseleave)="onPointer(false)"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut($event)"
>
  @for (toast of service.toasts(); track toast.id) {
    <div class="toast" data-testid="toast">
      <span class="nbo-glyph toast__check" data-glyph="check_circle" aria-hidden="true"></span>
      <span class="toast__text">{{ toast.messageKey | translate: toast.messageParams }}</span>
      @if (toast.undo) {
        <button type="button" class="toast__undo" data-testid="toast-undo" (click)="service.undo(toast.id)">
          {{ 'common.toast.undo' | translate }}
        </button>
      }
    </div>
  }
</div>
